import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getProductMoreOrLessSaled } from '../../../actions/inventoryActions'
import ReportByTypeView from '../../../containers/Inventory/Reports/ReportByType/ReportByType'
const ReportByType = () => {
  const [dateStart, setDateStart] = useState(new Date())
  const [dateEnd, setDateEnd] = useState(new Date())
  const [type, setType] = useState("mostSold")
  const dispatch = useDispatch()
  useEffect(() => {
    if(type){
      dispatch(getProductMoreOrLessSaled(dateStart, dateEnd, type))
    }
 

    return () => {

    }
  }, [type,dateStart, dateEnd])
  return (
    <ReportByTypeView
      type={type}
      setType={setType}
      dateStart={dateStart}
      setDateStart={setDateStart}
      dateEnd={dateEnd}
      setDateEnd={setDateEnd}
    />
  )
}

export default ReportByType